<template>
  <div v-resize="DomResize" class="source-wrap" ref="wrapper"
       :class="`${getClass(itemInfos)} ${targetRightViewClass('source')}`">
  </div>
</template>

<script>
// import { uuid } from "vue-uuid";
import { setCursorEnd, genUUID } from "@/services/common";
import { eventUtil } from "@/components/editor/modules/eventUtil";
import { debounce } from "@/components/editor/common";
import { mapGetters } from 'vuex';
// import { Header } from 'element-ui';

export default {
  name: "ContenteditableHTML",
  props: ["itemInfos", "flag", "editorMode", "isPreMts", "type", 'isOpenQa'],
  data() {
    return {
      SPECIAL_LANGUAGE: SPECIAL_LANGUAGE,
      correctNodes: [],
      children: [],
      position: require("../assets/images/position.png"),
      items: [],
      atomMap: {},
      // info:"",
    };
  },
  watch: {
    flag: {
      handler(value) {
        if (value === this.itemInfos.id + "source") {
          this.clearCorrect();
        } else if (!value) {
          this.getCorrect();
        }
      },
      deep: true
    },
    itemInfos: {
      handler() {
        setTimeout(() => {
          this.getCorrect();
        }, 500);
        this.items = this.getListItem();
        this.renderHtml();
      },
      deep: true,
      immediate: true
    },
    getEditorFontSizeInfo: {
      handler(val) {
        if (val) {
          this.getCorrect();
        }
      }
    }
  },
  computed: {
    ...mapGetters('editor', [
      'getUrlInfo',                        // 路由信息
      'getLoading',                        // 获取加载的信息
      'getEditorFontSizeInfo',             // 文字大小
    ]),
  },

  mounted() {
    // 页面注册滚动事件
    this.$nextTick(function () {
      document.addEventListener("mousedown", this.handleClick);
      if (window.navigator.userAgent.indexOf("MSIE") === -1) {
        this.observer();
      }
      this.renderHtml();
    })
    // window.setTimeout(() => {
    //   this.$store.dispatch('editor/setSourceeditEditorStatus', )
    // }, 500)
  },
  directives: {
    resize: {
      // 指令的名称
      bind(el, binding) {
        // el为绑定的元素，binding为绑定给指令的对象
        let width = "",
          height = "";
        function isResize() {
          const style = document.defaultView.getComputedStyle(el);
          if (width !== style.width || height !== style.height) {
            binding.value({ width: style.width, height: style.height }); // 关键(这传入的是函数,所以执行此函数)
          }
          width = style.width;
          height = style.height;
        }

        el.__vueSetInterval__ = setInterval(isResize, 300);
      },
      unbind(el) {
        clearInterval(el.__vueSetInterval__);
      }
    }
  },
  methods: {
    /**
 * @desc 特殊语种样式处理
 * @param {source} 源语言/目标语言
 * @returns {string} 返回样式类名
 */
    targetRightViewClass(source) {
      const { sourceLang } = this.getUrlInfo
      if (source === 'source') {
        return this.SPECIAL_LANGUAGE.indexOf(sourceLang) !== -1 ? 'right-view' : ''
      }
    },
    DomResize() {
      this.$nextTick(() => {
        if (!this.flag && !this.getLoadingInfo) {
          this.getCorrect();
        }
      });
    },
    getListItem() {
      const self = this;
      let reg = /<[^>]+>/g;
      // console.log(self.itemInfos)
      if (!!self.itemInfos && !!self.itemInfos.tagSourceSent) {
        let tagSourceSent = Object();
        if (typeof self.itemInfos.tagSourceSent === "string") {
          tagSourceSent = JSON.parse(self.itemInfos.tagSourceSent);
        } else {
          tagSourceSent = self.itemInfos.tagSourceSent;
        }
        if (
          Object.keys(tagSourceSent) &&
          tagSourceSent.fragments &&
          !!tagSourceSent.fragments.length &&
          tagSourceSent.fragments[0].atoms
        ) {
          let newTagSourceSent = Array();
          let sourceHTML = tagSourceSent.fragments[0].atoms;
          sourceHTML.forEach(item => {
            if (item.dataType === "text") {
              if (item.data) {
                if (reg.test(item.data)) {
                  //  console.log(item.data)
                  let arrEntities = { lt: "<", gt: ">", amp: "&" };
                  let dataHTMLResult = item.data.replace(
                    /&(lt|gt|amp);/gi,
                    function (all, t) {
                      return arrEntities[t];
                    }
                  );
                  // console.log(dataHTMLResult)
                  Reflect.set(item, "data", dataHTMLResult);
                }
              }
            }
          });
          newTagSourceSent = [...sourceHTML];
          // console.log(newTagSourceSent, "----")
          return newTagSourceSent;
        } else {
          return [];
        }
      }
    },
    reverse(str) {
      // str = str.replace(/</g, "&lt;");
      // str = str.replace(/>/g, "&gt;");
      // let strindex = str.indexOf("&gt");
      // let lt = str.substring(0, strindex);
      // str = str.replace(lt + "&gt", `<span class="text" info="${this.info}">`);
      // str = str.replace("&lt/span&gt", "</span>");
      // console.log(str)
      return str;
    },
    setStyle(str) {
      if (str) {
        let arr = str.split(';');
        return arr.filter(item => {
          if (item && item.indexOf('font-size') == -1) {
            return item;
          }
        }).join(";");
      }
    },
    getRenderHtml() {
      let html = "";
      // let html1="";
      this.atomMap = {};
      let idx = 0;
      this.items.forEach(item => {
        let info = this.getInfo(item, this.itemInfos);
        // this.info=info
        if (item.tagType === "text") {
          let style = this.setStyle(item.style) ? this.setStyle(item.style) : "";
          if (style) {
            style = style.replace('color:#FFFFFF', "")
          }
          html += `<span class="text" info="${info}" style='${style}'>${item.searchState ? item.dataHTML : this.reverse(item.data)
            }</span>`;
        }
        // else if (item.tagType === "open" || item.tagType === "close") {
        //   let img = this.getImgInfo(item);
        //   let id = this.itemInfos.id + item.tagType + idx++;
        //   this.atomMap[id] = item;
        //   html += `<img alt="此处为链接" src="${img}" id="source-tag-${id}" tagInfo="tagInfo" contenteditable="false" title="此处为链接" info="${info}" class="tag-img" width="25px"/>`;
        // } else if (item.tagType === "placeholder") {
        //   let id = this.itemInfos.id + item.tagType + idx++;
        //   this.atomMap[id] = item;
        //   html += `<img alt="此处为链接" id="source-tag-${id}" src="${this.position}" tagInfo="tagInfo" contenteditable="false" title="此处为链接" info="${info}" class="placeholder" width="15px"/>`;
        // }
      });
      return html;
    },
    renderHtml() {
      //修改为 HTML 拼接渲染，解决 v-for 不能清除部分标签
      if (this.$refs.wrapper) {
        this.$refs.wrapper.innerHTML = this.getRenderHtml();
        for (let key in this.atomMap) {
          document
            .getElementById("source-tag-" + key)
            .addEventListener("click", e => {
              e.preventDefault();
              // e.stopPropagation();
              // console.log("触发点击");

              this.handlePosition(this.atomMap[key]);
            });
        }
      }
    },
    //观察器
    observer() {
      const self = this;
      const dom = document.getElementById("source-" + self.itemInfos.id);
      if (!dom) {
        return;
      }
      const MutationObserver =
        window.MutationObserver ||
        window.WebKitMutationObserver ||
        window.MozMutationObserver; //浏览器兼容
      const config = { characterData: true, childList: true, subtree: true }; //配置对象
      const callback = function () {
        if (!self.flag && !this.getLoadingInfo) {
          self.getCorrect();
        }
      };
      const observer = new MutationObserver(debounce(callback, 100));
      observer.observe(dom, config);
    },
    getCorrect() {
      if (window.navigator.userAgent.indexOf("MSIE") >= 0) {
        return;
      }
      this.clearCorrect();
      if (!this.itemInfos.sourceTermSent || !this.itemInfos.sourceTermSent.length) {
        return;
      }
      this.label();
      this.setCorrect();
    },
    clearCorrect() {
      const df = document.getElementById("source-df" + this.itemInfos.id);
      if (df) {
        df.innerHTML = "";
      }
    },
    setCorrect() {
      const { sourceTermSent } = this.itemInfos;
      if (Array.isArray(sourceTermSent) && sourceTermSent.length) {
        sourceTermSent.forEach(cor => {
          let startNode, endNode, start, end;
          this.children.forEach(child => {
            if (
              cor.textIndex >= child.start &&
              cor.textIndex < child.end &&
              !startNode
            ) {
              startNode = child;
            }
            if (
              cor.textIndex + cor.textLength >= child.start &&
              cor.textIndex + cor.textLength <= child.end &&
              !endNode
            ) {
              endNode = child;
            }
          });
          if (startNode && endNode) {
            start = cor.textIndex - startNode.start;
            end = cor.textIndex + cor.textLength - endNode.start;
            this.correctNodes.push({
              startNode: startNode.node,
              endNode: endNode.node,
              start,
              end,
              index: cor.textIndex
            });
            //console.log(this.correctNodes,'this.correctNodes')
            this.rangeFun(startNode.node, endNode.node, start, end, cor);
          }
        });
      }
    },
    //判断选中文本是否换行
    wrapSent(startNode, endNode, start, end, idObj) {
      const range = document.createRange();
      const rangeH = document.createRange();
      // //选择区间
      range.setStart(startNode, start);
      range.setEnd(endNode, end);
      rangeH.setStart(startNode, start);
      rangeH.setEnd(endNode, start + 1);
      const sentHeight = range.getBoundingClientRect().height;
      const textHeight = rangeH.getBoundingClientRect().height;
      if (idObj.text !== range.toString()) {
        return false;
      }
      return sentHeight > textHeight;
    },
    rangeFun(startNode, endNode, start, end, idObj) {
      // console.log(startNode,endNode)
      const dom = document.getElementById("source-df" + this.itemInfos.id);
      const domVw = dom.getBoundingClientRect();
      const top = dom.scrollTop;
      const range = document.createRange();
      const isWrap = this.wrapSent(startNode, endNode, start, end, idObj);
      if (isWrap) {
        //  换行选择
        for (let i = start; i < end; i++) {
          range.setStart(startNode, i);
          range.setEnd(endNode, i + 1);
          const obj = {
            isFirst: i === start,
            isEnd: i === end - 1,
          };
          this.setRangeDiv(idObj, range, domVw, top, obj);
        }
      } else {
        range.setStart(startNode, start);
        range.setEnd(endNode, end);
        // console.log(range.toString(),idObj.text)
        if (range.toString() !== idObj.text) return;
        const obj = {
          isFirst: true,
          isEnd: true,
        };
        this.setRangeDiv(idObj, range, domVw, top,obj);
      }
    },
    setRangeDiv(idObj, range, domVw, top,isStartOrEnd) {
      // console.log(idObj,range,domVw,top,rangeH)
      const rect = range.getBoundingClientRect();
      const div = document.createElement("div");
      const { isFirst, isEnd } = isStartOrEnd;
      const classNames = ["correct-item"];
      if (isFirst) {
        classNames.push("correct-item-start");
      }
      if (isEnd) {
        classNames.push("correct-item-end");
      }
      div.classList.add(...classNames);
      div.style.pointerEvents = "unset";
      div.style.left = rect.left - domVw.left + "px";
      div.style.width = rect.width  + "px";
      // div.style.height = rect.height + 'px'
      div.style.height = 1 + 'px'
      div.style.top = rect.top + top - domVw.top - 4 + "px";
      div.style.position = "absolute";
      // div.style.background = "#0167FF";
      div.style.borderTop = "2px solid #ff9c00";
      // div.style.opacity = "0.5";
      // 另外再给新创建的div添加一个子元素作为伪元素
      var pseudoElement = document.createElement('div');
      pseudoElement.classList.add('before-element');
      div.insertBefore(pseudoElement, div.firstChild);
      const df = document.getElementById("source-df" + this.itemInfos.id);
      df.appendChild(div);
    },
    //数据处理
    label() {
      this.setCorrectHTML();
      const div = document.getElementById("source-" + this.itemInfos.id);
      let children = [];
      this.setTextNode(children, div);
      this.children = children;
    },
    //递归获取text节点
    setTextNode(children, div) {
      const childNodes = div.childNodes;
      for (let i = 0; i < childNodes.length; i++) {
        const element = childNodes[i];
        if (element.childNodes.length > 1) {
          this.setTextNode(children, element);
        } else if (element.nodeType === 3) {
          const node = element;
          const len = children.length ? children[children.length - 1].end : 0;
          children.push({ node, start: len, end: node.length + len });
        } else if (element.firstChild && element.firstChild.nodeType === 3) {
          const node = element.firstChild;
          const len = children.length ? children[children.length - 1].end : 0;
          children.push({ node, start: len, end: node.length + len });
        } else {
          this.setTextNode(children, element);
        }
      }
    },
    setCorrectHTML() {
      this.$nextTick(() => {
        const dom = document.getElementById("source-" + this.itemInfos.id);
        const h = dom.offsetHeight;
        const w = dom.offsetWidth;
        const df = document.getElementById(`source-df${this.itemInfos.id}`);
        df.style.height = h + "px";
        df.style.width = w + "px";
        df.style.padding = "4px 8px";
      });
    },
    //术语高亮截止
    handleClick(e) {
      if (e.target.getAttribute("tagInfo")) {
        eventUtil.preventDefault(e);
      }
    },
    //获取句子信息
    getInfo(row, itemInfos) {
      let infos;
      if (Object.keys(row).length) {
        infos = `${row.atomKey || itemInfos.templateKey}*${row.dataType ||
          "text"}*${row.id ||
          `${parseInt(itemInfos.id.toString().substr(0, 5))}`}*${row.sort ||
          `${parseInt(itemInfos.id.toString().substr(0, 5))}`}*${row.style ||
          "style"}*${row.tagType || "text"}*${genUUID()}`;
        if (row.dataType === "tag") {
          infos = `${infos}*${row.data || 1}`;
        }
      }
      return infos;
    },

    //点击tag插入
    handlePosition(info) {
      let cursorPositionTargetInfo = this.$store.getters["editor/getCursorPositionTargetInfo"];
      console.log(cursorPositionTargetInfo, 'cursorPositionTargetInfo-----');
      let currentSentenceIdInfo = this.$store.getters["editor/getCurrentSentenceIdInfo"];
      let bool = !!this.itemInfos && !!this.itemInfos.id && !!currentSentenceIdInfo && !!currentSentenceIdInfo.currentId;
      if (bool && parseInt(this.itemInfos.id) === parseInt(currentSentenceIdInfo.currentId)) {
        let tempSentenceIdInfo = this.$store.getters[
          "editor/getTempSentenceIdInfo"
        ];
        const { type, taskId, taskType } = this.getUrlInfo
        let fileId = null;
        if (type === "project") {
          let fileInfo = this.$store.getters["editor/getFileInfo"];
          fileId = fileInfo.id;
        } else if (type === "task" || type === "school") {
          let fileTaskInfo = this.$store.getters["editor/getFileTaskInfo"];
          fileId = fileTaskInfo.fileId;
        }
        if (cursorPositionTargetInfo.length) {
          let tempAtom = Array()
          let tempStr = "";
          let $index = null
          if (cursorPositionTargetInfo[3]) {
            $index = cursorPositionTargetInfo[3].index
          }
          if (cursorPositionTargetInfo[2] === "header") {
            let tagSourceSent = cursorPositionTargetInfo[1].tagSourceSent.atoms;
            tagSourceSent.splice($index, 0, info);
            tempAtom = [...cursorPositionTargetInfo[0].tagSourceSent.atoms, ...tagSourceSent];
          } else if (cursorPositionTargetInfo[2] === "middle") {
            cursorPositionTargetInfo.pop();
            cursorPositionTargetInfo.map((item, index) => {
              if (
                Reflect.has(item.tagSourceSent, "atoms") &&
                !!item.tagSourceSent.atoms &&
                !!item.tagSourceSent.atoms.length
              ) {
                item.tagSourceSent.atoms.map(item2 => {
                  tempAtom.push(item2);
                  tempStr = `${tempStr}${item2.data}`;
                });
                if (index === 0) {
                  tempAtom.push(info);
                  // console.log(tempAtom,"tempAtom");
                }
              }
            });
          } else if (cursorPositionTargetInfo[2] === "tail") {
            let tagSourceSent = cursorPositionTargetInfo[0].tagSourceSent.atoms;
            tagSourceSent.push(info);
            tempAtom = [...tagSourceSent, ...cursorPositionTargetInfo[1].tagSourceSent.atoms];
          }
          if (tempAtom.length) {
            this.$nextTick(() => {
              //获取数据信息
              let targetTemp = Object();
              let params = Object();
              Reflect.set(targetTemp, "sort", 0);
              Reflect.set(targetTemp, "text", null);
              Reflect.set(targetTemp, "type", null);
              Reflect.set(targetTemp, "atoms", tempAtom);
              Reflect.set(params, "sourceTagFragmentVo", null);
              Reflect.set(params, "targetTagFragmentVo", targetTemp);
              Reflect.set(params, "constTime", 0);
              Reflect.set(params, "taskId", taskId);
              Reflect.set(params, "taskType", 1);
              Reflect.set(params, "isSaveVersion", 1);
              Reflect.set(params, "sentId", tempSentenceIdInfo.item.id);
              Reflect.set(params, "content", tempStr);
              Reflect.set(params, "status", tempSentenceIdInfo.item.status);
              Reflect.set(params, "fileId", fileId);
              if (this.isOpenQa && ['task', 'school'].includes(type)) {
                let params3 = Object();
                Reflect.set(params3, 'fileId', fileId);
                Reflect.set(params3, 'taskId', taskId);
                Reflect.set(params3, 'sentId', (tempSentenceIdInfo.item.id));
                Reflect.set(params3, 'taskType', parseInt(taskType));
                // 当前句子QA信息
                this.$store.dispatch('editor/fragmentQAInfo', params3);
                const QA_ListParams = {
                  fileId,
                  taskId,
                  // transModel: 1
                }
                // QA列表刷新
                this.$store.dispatch('editor/QACheckFileTaskInfo', QA_ListParams);
              }
              this.$store
                .dispatch("editor/updateTargetInfo", {
                  params: params,
                  type: 4
                })
                .finally(() => {
                  this.$store.dispatch(
                    "editor/recordCursorPositionTarget",
                    Object()
                  );
                  let dom = document.getElementById(`target-${params.sentId}`);
                  this.bus.$emit("changeFlag", true)
                  // 如果可编辑div最后一个节点是img那么在不可编辑的节点后加一个不显示内容的文本节点
                  // if (dom.lastChild.nodeName === "IMG") {
                  //   dom.appendChild(document.createTextNode("\u00A0"));
                  // }
                  setCursorEnd(dom);
                  this.clearCorrect();
                });
            });
          } else {
            this.$message.closeAll();
            this.$message.warning("获取数据失败,请刷新重试");
          }
        } else {
          this.$message.closeAll();
          this.$message.warning("请先获取译文的插入位置");
        }
      } else {
        this.$store.dispatch("editor/recordCursorPositionTarget", Object());
        // this.$store.dispatch("editor/setCursorId", { currentId: null, currentIdType: null })
        this.$message.closeAll();
        this.$message.warning("请先获取译文的插入位置或者原文译文不是同一行");
      }
    },

    getClass(row) {
      if (!!row && !!row.tagSourceSent) {
        let tagSourceSent = JSON.parse(row.tagSourceSent);
        if (
          !!tagSourceSent &&
          !!tagSourceSent.fragments &&
          !!tagSourceSent.fragments.length
        ) {
          let firstChild = tagSourceSent.fragments[0];
          if (!!firstChild && !!firstChild.atoms && !!firstChild.atoms.length) {
            let firstChildAtoms = firstChild.atoms[0];
            if (!firstChildAtoms.data) {
              return "source-wrap-empty";
            }
          }
        }
      }
    },
    getImgInfo(info) {
      if (info.tagType === "open") {
        if (info.data) {
          return info.data < 10
            ? require(`../assets/images/left_0${info.data}.png`)
            : require(`../assets/images/left_${info.data}.png`);
        }
      } else if (info.tagType === "close") {
        if (info.data) {
          return info.data < 10
            ? require(`../assets/images/right_0${info.data}.png`)
            : require(`../assets/images/right_${info.data}.png`);
        }
      }
    }
  }
};
</script>
<style lang="less" >
.df .correct-item-start::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0px;
  width: 2px;
  height: 2px;
  background-color: #ff9c00;
}
.df .correct-item-end::after {
  content: "";
  position: absolute;
  right: 0px;
  top: 0px;
  width: 2px;
  height: 2px;
  background-color: #ff9c00;
}
</style>

<style scoped lang="less">
/deep/.text {
  word-wrap: break-word;
}
// .source-wrap {
//   word-break: break-all;
// }
</style>
